import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

//Actions
import { clearRedux } from 'Redux/actions';
import { useEffect, useState } from "react";

const Details = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux states
    const { openModal, data } = useSelector(state => state.maintenanceWarningEventsDetailsRedux);

    //Local States
    const [items, setItems] = useState(null)

    const closeModal = () => {
        dispatch(clearRedux("MAINTENANCE_WARNINGS_EVENTS"));
        setItems(null);
    }

    useEffect(() => {
        if (openModal && data) {
            try {
                const currentData = JSON.parse(data);
                const coordinate = currentData?.gpsGap?.lastGps?.coordinate;
                if (coordinate) {
                    currentData.gpsGap.lastGps.coordinate = JSON.stringify(coordinate);
                }
                setItems(currentData);
            } catch (exc) { }
        }
    }, [openModal, data]);

    return (
        <Modal
            open={openModal}
            title={messages['maintenancewarningevent_main_details']}
            handleClose={() => {
                closeModal();
            }}
            position="right"
            size="small"
            headerStyle={{ zIndex: "9" }}
        >
            <ModalBody>
                <div style={{ margin: 10 }}>
                    {items ? (
                        <div style={{ marginBottom: 30 }}>
                            <JsonView data={items} shouldExpandNode={allExpanded} style={defaultStyles} />
                        </div>
                    ) : (
                        <div style={{
                            display: 'flex',
                            height: 30,
                            width: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: '#212529',
                            opacity: 0.6
                        }}>
                            {messages['maintenancewarningevent_main_no_data']}
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter style={{ zIndex: "9" }}>
                <Button className="btn btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages["common_cancel"]}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default Details;